import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
// module
import TypeText from './TypeText'
import TypeTextImage from './TypeTextImage'
import TypeTextMovie from './TypeTextMovie'
import TypePdf from './TypePdf'
import TypeSound from './TypeSound'
import TypeOpinionaire from './TypeOpinionaire'
import TypeSoundBroadcast from './TypeSoundBroadcast'
import TypeKeikai from './TypeKeikai'
import TypeImages from './TypeImages'
import TypeMovies from './TypeMovies'
import TypeDisaster from './TypeDisaster'
import TypeMailmag from './TypeMailmag'
import TypeEmergency from './TypeEmergency'
import TypeImportant from './TypeImportant'
import TypeRapidInfo from './TypeRapidInfo'
import TypeRapidNotice from './TypeRapidNotice'

export default {
  name: 'NoticeDetail',
  components: {
    Loading,
    // module
    TypeRapidInfo,
    TypeRapidNotice,
    TypeText,
    TypeTextImage,
    TypeTextMovie,
    TypePdf,
    TypeSound,
    TypeOpinionaire,
    TypeSoundBroadcast,
    TypeKeikai,
    TypeImages,
    TypeMovies,
    TypeDisaster,
    TypeMailmag,
    TypeEmergency,
    TypeImportant
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    listType: {
      type: Number,
      requires: true,
      default: 2,
    },
    noticeId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      deleteTargetId: null
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    console.log('listType: ', this.listType)
    console.log('noticeId: ', this.noticeId)
    console.log('repeatedDelivery: ', this.repeatedDelivery)
    this.init()
  },
  beforeDestroy () {
    this.resetDetail()
  },
  computed: {
    ...mapState({
      categoryName: state => state.notice.categoryName,
      userIdentity: state => state.noticeDetail.targetId,

      // model
      infoModel: state => state.noticeDetail.infoModel,
      contentModel: state => state.noticeDetail.contentModel,
      deliveryPlanKbn: state => state.noticeDetail.deliveryPlanKbn,
      immediateDelivery: state => state.noticeDetail.immediateDelivery,
      reservedDelivery: state => state.noticeDetail.reservedDelivery,
      repeatedDelivery: state => state.noticeDetail.repeatedDelivery,
      noticeTypeMstModel: state => state.noticeDetail.noticeTypeMstModel,
      deliveryType: state => state.noticeDetail.deliveryType,

      noticeTypeMstUuid: state => state.noticeDetail.noticeTypeMstUuid,
      deliveryStatus: state => state.noticeDetail.deliveryStatus,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,

      // お知らせ配信管理の場合、true
      isBot: state => state.noticeList.isBot,
      noticeModel: state => state.notice.noticeModel,
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      getPermission: 'permission/get',
      isAdmin: 'auth/isAdmin'
    }),

    resultTarget() {
      const type = this.getResult('deliveryToKbn')
      console.log('type', type)
      // 属性配信
      if (this.infoModel.deliveryToKbn === 1) {
        const attributes = this.infoModel.deliveryToAttributeGroups
          .map(item => item.attributeTypeName + ' : ' + item.attributeGroupName)
        return type + '（' + attributes.join('、') + '）'
      // 個別配信
      } else if (this.infoModel.deliveryToKbn === 2) {
        return type + '（' + this.infoModel.deliveryToDevice.nickName + '）'
      } else {
        return type
      }
    },
    resultNoticeType() {
      const mst = this.noticeTypeMstModel.find(
        item => item.noticeTypeMstUuid === this.noticeTypeMstUuid
      );
      return mst ? mst.noticeType : '';
    },
    // result
    deliveryTerm() {
      if (this.repeatedDelivery && this.repeatedDelivery.deliveryStartDt) {
        return this.repeatedDelivery.deliveryStartDt.replace(/-/g, '/') + ' ～ ' + this.repeatedDelivery.deliveryEndDt.replace(/-/g, '/');
      } else {
        return ''
      }
    },
    deliveryPatternList() {
      const array = $.extend(true, [], Constants.Notice.DeliveryPattern);
      array.forEach((item, index) => {
        item.selected = this.deliveryPattern[index] === '1'
      })
      return array.sort(Utility.sortByKey('index', true))
      // console.log(array);
      // // return Constants.Notice.DeliveryPattern.sort(Utility.sortByKey('index', true))
      // return Constants.Notice.DeliveryPattern;
    },
    deliveryPattern() {
      return Utility.bitArrayByInt(this.repeatedDelivery.deliveryPattern)
    },

    // enable
    disableStatusButton () {
      return this.listType !== 1
    },
    // 配信停止ボタンを非活性にする場合、trueを返す
    disableStopButton () {
      // 配信状態が「配信停止」「配信終了」の場合、trueを返す
      return this.deliveryStatus === 8 || this.deliveryStatus === 4
    },
    disableResendButton () {
      return this.listType !== 1
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 配信停止
      if (this.confirmKey === 'stop') {
        if (to) this.stopDelivery()
      }
      // 再配信
      if (this.confirmKey === 'resend') {
        if (to) this.resend()
      }
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'noticeDetail/loadModel',
      resetDetail: 'noticeDetail/reset',
      showNoticeDeliveryStatusModal: 'noticeDeliveryStatusModal/show',
      deleteNoticeDetail: 'notice/deleteNoticeDetail',
    }),

    init () {
      this.loading = true

      // パラメータ
      let noticeParams = {}
      if (this.listType === 1) {
        noticeParams.noticeDeliveryUuid = this.noticeId
      } else {
        noticeParams.noticeUuid = this.noticeId
      }
      // console.log('noticeParams', noticeParams)

      // データ読出し
      this.loadModel({
        targetId: this.noticeId,
        listType: this.listType,
        noticeParams: noticeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.$router.push({
            name: 'Notice'
          });
          // this.showError(error || null)
        })
    },

    getResult (key) {
      switch (key) {
        // 配信情報
        case 'serviceName':
          return this.infoModel[key]
        case 'deliveryToKbn':
          return Utility.getConstantsLabel(['ContentsApply', 'DeliveryToKbn'], this.infoModel[key])
        case 'deliveryStatus':
          var k = this.listType === 1
            ? 'DeliveryStatus'
            : this.listType === 2
              ? 'ReservedNoticeStatus'
              : 'RepeatedNoticeStatus'
          return Utility.getConstantsLabel(['Notice', k], this.deliveryStatus)
        case 'deliveryLocationCount':
        case 'openedLocationCount':
        case 'thumbupLocationCount':
        case 'deliverySpCount':
        case 'openedSpCount':
        case 'thumbupSpCount':
          return this.listType === 1
            ? Utility.numberFormat(this.infoModel[key], 0, true)
            : Constants.BlankValue

        // // 繰り返し配信期間とパターン
        // case 'repeatedDeliveryPattern':
        //   if ()

        //TODO 詳細情報
        case 'title':
          return this.contentModel[key] || this.contentModel['question'] || '　'
        case 'body':
          return Utility.decodeBraak(this.contentModel[key])

        default:
          return ''
      }
    },

    // モジュールの表示設定
    showModule (type) {
      const mst = this.noticeTypeMstModel.filter(item => item.noticeTypeMstUuid === this.noticeTypeMstUuid)
      console.log('@', mst[0].noticeType, type)
      if (!mst.length) return false
      return mst[0].noticeType === type
    },

    confirmStatus () {
      if (this.disableStatusButton) return

      this.showNoticeDeliveryStatusModal()
    },
    confirmStop () {
      this.showConfirm({
        key: 'stop',
        title: '配信停止',
        body: 'お知らせの配信を停止します。<br>よろしいですか',
        acceptLabel: '配信停止'
      })
    },
    confirmResend () {
      if (this.disableResendButton) return

      const count = this.infoModel.deliveryLocationCount - this.infoModel.openedLocationCount;

      this.showConfirm({
        key: 'resend',
        title: '再配信',
        body: '未開封ロケーション' + count + '件に再配信します。<br>よろしいですか',
        acceptLabel: '再配信'
      })
    },

    /**
     * 配信停止
     */
    stopDelivery () {
      this.processing = true

      let parameters = {
        request: {
          actionType: 1
        }
      }
      if (this.listType === 1) {
        parameters.noticeDeliveryUuid = this.noticeId
      } else {
        parameters.noticeUuid = this.noticeId
      }
      console.log('register data', parameters)

      // 配信停止
      ApiManager.request(
        [this.isBot
          ? 'noticeBot'
          : 'notice'],
        [this.listType === 1
          ? 'v1NoticeDeliveryActionTypePatch'
          : 'v1NoticeActionTypePatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '配信停止',
              body: 'お知らせの配信を停止しました。'
            })

            this.$router.go(-1);

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }

        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    /**
     * 再配信
     */
    resend () {
      this.processing = true

      let parameters = {
        noticeDeliveryUuid: this.noticeId
      }
      console.log('register data', parameters)

      // 再配信
      ApiManager.request(
        [this.isBot
          ? 'noticeBot'
          : 'notice'],
        ['v1NoticeDeliveryResendPost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '再配信',
              body: 'お知らせの再配信をしました。'
            })

            this.$router.go(-1);

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }

        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteItem () {
      let id = ''
      this.deleteTargetId = this.noticeId
      if (this.listType === 1) {
        id = Utility.getObjectArrayValue(this.noticeModel, 'noticeDeliveryUuid', this.deleteTargetId, 'noticeDeliveryId')
      } else {
        id = Utility.getObjectArrayValue(this.noticeModel, 'noticeUuid', this.deleteTargetId, 'noticeId')
      }
      this.showConfirm({
        key: 'delete',
        title: '',
        body: 'ID 「' + id + '」 のお知らせを削除しますか？',
        acceptLabel: '削除'
      })
    },
    deleteData () {
      this.processing = true
      let noticeParams = {
        noticeDeliveryUuid: this.noticeId
      }
      this.deleteNoticeDetail({
        noticeParams: noticeParams
      })
          .then(res => {
            this.$router.push({
              name: 'Notice'
            });
          })
          .catch(error => {
            this.showError(error || null)
            this.processing = false
          })
    }
  }
}